<div class="container">
  @if (!isUnsubscribed) {
  <div class="row withImage">
    <div class="col-12 col-md-7">
      <h1 tabindex="0" class="titleTyp1 mb-4 me-4 pt-5">
        WANT TO STOP GETTING ENERGY UPDATES?
      </h1>
      <h2 class="mb-2 fs-17 text-col35">Here’s what you’ll miss out on:</h2>
      <ul class="mb-4">
        <li>Emails about the latest energy prices when available</li>
        <li>Reminders, offers, and tips to help you save money on your bills</li>
      </ul>
      @if (isLoading) {
      <div class="skeleton-wrapper noBdr">
        <div class="container">
          <div class="skeleton-wrapper-inner">
            <div class="skeleton-wrapper-body">
              <div class="p-4 mb-4"></div>
              <span class="box d-inline-block w-25 p-4 mb-4 me-4"></span>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div class="">
        <div class="mb-4">
          <form [formGroup]="emailFormGroup" class="">
            <mat-form-field floatLabel='never' class="selectTyp1 ctm-input w-100 mb-2" appearance="fill">
              <input [disabled]="isInputDisabled" matInput appAlphabetOnly formControlName="email" type="text"
                class="inputTyp1 fw500" />
              @if (!emailFormGroup.controls['email'].valid && emailFormGroup.controls['email'].touched) {
              <mat-error aria-hidden="true">{{ getErrorEmail() }}</mat-error>
              }
            </mat-form-field>
          </form>
          @if (errordata) {
          <span class="text-danger">{{errordata}}</span>
          }
        </div>
        <div>
          <button id="EnergyComparison_UnsubscribeModal_WantToStopGettingEnergyUpdates_Unsubscribe"
            class="btn btn-primary blockXS m-md-2 position-relative" (click)="result()" [disabled]="isSubmitted" [ngClass]="isSubmitted ? 'animate' : ''">
            <span class="spinner"></span>
            <span class="text">Unsubscribe</span>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="row withImage">
    <div class="col-12 col-md-7">
      <h1 tabindex="0" class="titleTyp1 mb-4 me-4 pt-5">
        YOU’RE NOW UNSUBSCRIBED FROM ENERGY UPDATES
      </h1>

      <h2 class="mb-4 fs-23 fs17-XS text-col35"> You’ll no longer be sent emails about new energy tariffs.</h2>

      <div class="mb-4 fs-17 text-col35">
        If you change your decision, sign in and subscribe again.
      </div>
    </div>
  </div>
  }

</div>